import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ListContainer = styled(Container)`
  margin-top: 10px;
`;

export const KeyFeaturesContainer = styled.ol`
  list-style: none;
  margin-bottom: 0;
  padding-inline-start: 0;
  & > li {
    align-items: center;
    display: flex;
    gap: 5px;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
